import { Component, ViewChild, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { NotifyService } from 'src/app/home/services/notify.service';
import { MasterdataService } from 'src/app/home/services/masterdata.service';
import { timestampFormat } from '../../../../../app/config/moment';
import { PaginationComponent } from '../../../common/pagination/pagination.component';
import { FormsModule } from '@angular/forms';

@Component({  
  selector: 'app-notify-list',
  standalone: true,
  imports: [CommonModule, PaginationComponent, FormsModule],
  templateUrl: './notify-list.component.html',
  styleUrls: ['./notify-list.component.scss', '../../../../app.component.scss']
})

export class NotifyListComponent implements OnInit {
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  searchTerm: string = '';
  public notifylist: any = [];
  public timestampFormat = timestampFormat;
  public paginationData: any = { totalPage: 0 };
  public currentPage: number = 1;
  public searchInput: string = '';
  public raisedSortValue: string;
  public encodedSearchInput: string = '';
  public orderBy:string = "asc";

  public selectedStatusForAlert = [];
  public selectedStatusForStore = [];
  
  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;

  constructor(public location: Location, public notifyService: NotifyService, public masterdataService: MasterdataService) { }

  ngOnInit(): void {
    this.getnotifyList(this.currentPage, this.selectedStatusForAlert, this.raisedSortValue, this.selectedStatusForStore);
  }
  
  goBack() {
    this.location.back();
  }

  resetSearch(): void {
    this.searchTerm = '';
    this.searchInput = '';
    this.encodedSearchInput = '';
    this.getnotifyList(this.currentPage, this.selectedStatusForAlert, this.raisedSortValue, this.selectedStatusForStore);
  }

  reset(event: Event) {
    event.preventDefault();
    this.searchInput = '';
    this.encodedSearchInput = '';
    this.isSearch = false; 
    this.isFilter = false;
    this.isFilterResult = true;
    this.getnotifyList(this.currentPage);
  }

  getnotifyList(currentPage: number, selectedStatusForAlert: Array<String> = [], raisedSortValue: String = "", selectedStatusForStore: Array<String> = []) {
    this.notifyService.getnotifyList(currentPage, selectedStatusForAlert, raisedSortValue, selectedStatusForStore).subscribe((res) => {
      if (res.data) {
        this.notifylist = res.data.data;
        this.paginationData.totalPage = Math.ceil(res.data.total / 15);
      }
    });
  } 

  raisedAtSort(){
    this.isFilter = true;

    if (this.raisedSortValue === "asc") {
      this.raisedSortValue = "desc";
    }else{ 
      this.raisedSortValue = this.orderBy;
    }

    this.onFilterChange();
  }

  openStatusListPopup(event){
    document.getElementById("status_for-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("status_for-popup");
  }

  openTypesListPopup(event){
    document.getElementById("type_for-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("type_for-popup");
  }

  openStoreListPopup(event){
    document.getElementById("store_for-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("store_for-popup");
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active")
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }

  onSelectStatus(event){
    if (event.target.checked) {
      this.selectedStatusForAlert.push(event.target.value);
    }else{
      this.selectedStatusForAlert = this.selectedStatusForAlert.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;

    this.onFilterChange();
  }
 
  onSelectStore(event){
    if (event.target.checked) {
      this.selectedStatusForStore.push(event.target.value);
    }else{
      this.selectedStatusForStore = this.selectedStatusForStore.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;

    this.onFilterChange();
  }

  onFilterChange(){
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }

    this.getnotifyList(this.currentPage,this.selectedStatusForAlert, this.raisedSortValue, this.selectedStatusForStore)
  }

  getQueryPage(event: any) {
    this.currentPage = event;
    this.getnotifyList(this.currentPage, this.selectedStatusForAlert, this.raisedSortValue, this.selectedStatusForStore);
  }

  onSearchSubmit(event: Event) {
    event.preventDefault();
    this.currentPage = 1;
    this.getnotifyList(this.currentPage);
  }
}
